module.exports = __webpack_public_path__ + "static/media/verification.870b01e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-verification/verification.png
// module id = 1691
// module chunks = 0